import type { RecipeQueryResponse } from '@library/api-menu-experience'
import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { useFetchRecipe } from './useFetchRecipe'
import { useFetchRecipeExperience } from './useFetchRecipeExperience'

type UseRecipeDetailDataInput = {
  menuId: string
  recipeUuid: string | null
  numPortions: number
  deliveryDate: string
  shouldFetchOptions?: boolean
  collectionId?: string
  isMenuExperienceRecipeDetailEnabled: boolean
}

type UseRecipeDetailDataResult = {
  loading: boolean
  recipe: MenuRecipe | RecipeQueryResponse | null
  error: boolean
  reload: () => void
}

export const useRecipeDetailData = ({
  menuId,
  recipeUuid,
  numPortions,
  deliveryDate,
  shouldFetchOptions = true,
  collectionId,
  isMenuExperienceRecipeDetailEnabled,
}: UseRecipeDetailDataInput): UseRecipeDetailDataResult => {
  const shouldFetch = shouldFetchOptions && Boolean(recipeUuid)

  const v3 = useFetchRecipe(
    menuId,
    recipeUuid,
    numPortions,
    deliveryDate,
    shouldFetch && !isMenuExperienceRecipeDetailEnabled,
    collectionId,
  )

  const experience = useFetchRecipeExperience(
    menuId,
    recipeUuid,
    numPortions,
    deliveryDate,
    shouldFetch && isMenuExperienceRecipeDetailEnabled,
    collectionId,
  )

  const active = isMenuExperienceRecipeDetailEnabled ? experience : v3

  return {
    loading: active.loading,
    recipe: active.recipe,
    error: active.error,
    reload: active.reload,
  }
}
